import { useEffect, useState, useCallback, useRef } from "react";

const useProgress = (loading = false, ms = 300 * 1000) => {
  const [progress, setProgress] = useState(0);
  const timerRef = useRef(null);

  const resetProgress = useCallback(() => {
    setProgress(0);
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  useEffect(() => {
    if (loading) {
      setProgress(0);
      if (timerRef.current) clearInterval(timerRef.current);

      timerRef.current = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            clearInterval(timerRef.current);
            timerRef.current = null;
            return 100;
          }
          return Math.min(prev + 1, 100);
        });
      }, ms / 100);
    } else {
      resetProgress();
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [loading, ms, resetProgress]);

  return [progress, resetProgress];
};

export default useProgress;
